module.exports = __webpack_public_path__ + "static/sec1-b57afe4dfc5f9a7b89b5f97a750def84.png";